import React, { useEffect, useState, useContext } from "react";
import Table from "./Table";
import { dateObjToStrDate } from "../helpers/date_conversion";
import { ButtonWIcon } from "./Inputs";
import { newAidContext } from "./ClientPage"; 
import { AddNewAidRecordWindow } from "./AddNewAidRecord"
import { refreshClientProject } from './ClientProjectOverview';
import { postStuff } from "../helpers/auth";
import { confirmAlert } from 'react-confirm-alert';
import { AlertsContext } from './Layout'
import { authenticatedContext } from "../App";

export function ClientsAidRecords({ projectId, clientId}) {
  const [reqUrl, setReqUrl] = useState("");
  const [timeSort, setTimeSort] = useState(-1);
  const [timeRange, setTimeRange] = useState([
    {
      startDate: null,
      endDate: null,
      key: 'selection'
    }
  ]);
  const [datePickerOpen, setDatePickerOpen] = useState(false);
  const [newAidOpen, setNewAidOpen] = useContext(newAidContext);
  const [refresh, setRefresh] = useContext(refreshClientProject);
  const {authenticated, setAuthenticated} = useContext(authenticatedContext);
  const addAlertBanner = useContext(AlertsContext);

  useEffect(() => {
    const start_d = timeRange[0].startDate ? dateObjToStrDate(timeRange[0].startDate) : "null"
    const end_d = timeRange[0].endDate ? dateObjToStrDate(timeRange[0].endDate) : "null"
    setReqUrl(`/client/${clientId}/project/${projectId}/aid_records/${start_d}/${end_d}/${timeSort}`);

  }, [timeRange, timeSort, clientId, projectId, refresh]);

  function openNewAidContext(){
    window.scroll({ top: 0, left: 0, behavior: 'smooth' });
    setNewAidOpen(true)
  }

  function handleDeletePress(aid_id){
    console.log(aid_id);
    confirmAlert({
      title: 'Opravdu chcete smazat podporu?',
      message: 'Tato akce se nedá vrátit.',
      buttons: [
        {
          label: 'Ano',
          onClick: ()=>{deleteFr(aid_id)}
        },
        {
          label: 'Ne'
        }
      ]
    });
  }

  function deleteFr(aid_id){
    
    postStuff('aid_record/delete/', {aid_record_id: aid_id}).then((res) => {
          if (res.status === 200) {
              addAlertBanner("Změny uloženy", "success")
              setRefresh(!refresh)

          } else if(res.status === 403){
              addAlertBanner("Na mazání podpory nemáte dostatečné oprávnění", "warning")
              
          }else if (res.status === 401) {
                setAuthenticated(false);
            }
          else {
              addAlertBanner("Něco se pokazilo", "danger")
          }
  }); 
  }


  return (
    <div className="aid-records">
      {newAidOpen && <AddNewAidRecordWindow projectId={projectId} clientId={clientId}/>}
      <div className='new-aid-header'>
        <span>Veškerá poskytnutá pomoc</span>
        { projectId !== 0 && 
        <ButtonWIcon text={"Přidat záznam"} iconSrc={"/img/svg/add.svg"} onClick={openNewAidContext} />
      }
      </div>
      <Table
        reqUrl={reqUrl}
        redirectOnRecordClick={false}
        updateShit={refresh}
        headers={[
          {
            name: "Čas",
            dataKey: "ts",
            search: {
              value: timeRange,
              setValue: setTimeRange,
              datePickerOpen: datePickerOpen,
              setDatePickerOpen: setDatePickerOpen
            },
            sort: {
              value: timeSort,
              setValue: setTimeSort
            },
            type: "time",
          },
          {
            name: "Akce",
            dataKey: false,
            search: false,
            sort: false,
            type: "aid_actions"
        }

      ]} 
        actions={{
          controls:{
            deleteSrc: "/img/svg/bin.svg",
            onDeletePress: handleDeletePress,
          }
        }}
      />
    </div>
  );
}